module.exports = __webpack_public_path__ + "static/logo-only-glay-ebb3f6a147e4f4a6c04e5371bce8684b.svg";